module.exports = __webpack_public_path__ + "assets/language-squares/ko@2x-fc13234062f79cbc5131ac8b59df09af.jpg";